var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHistory = function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "history_svg__a",
    width: 28,
    height: 28,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h28v28H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#history_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B1F",
    d: "M8.12 23.558q-.764 0-1.356-.5a2.06 2.06 0 0 1-.724-1.264l-1.64-9.83q-.082-.483.224-.862a.99.99 0 0 1 .808-.378h17.136q.504 0 .808.378t.225.862l-1.64 9.83q-.132.764-.725 1.263-.592.5-1.356.5zM6.3 12.474l1.443 9.03q.022.135.118.22.095.084.23.084H19.91q.134 0 .23-.084a.36.36 0 0 0 .117-.22l1.443-9.03zm5.367 4.375h4.667a.85.85 0 0 0 .623-.251.85.85 0 0 0 .252-.624.85.85 0 0 0-.252-.623.85.85 0 0 0-.623-.252h-4.667a.85.85 0 0 0-.623.252.85.85 0 0 0-.252.624q0 .372.252.623a.85.85 0 0 0 .623.251M7 9.333a.85.85 0 0 1-.623-.251.85.85 0 0 1-.252-.624q0-.372.252-.623A.85.85 0 0 1 7 7.583h14q.372 0 .623.252a.85.85 0 0 1 .252.624.85.85 0 0 1-.252.623.85.85 0 0 1-.623.251zm2.333-3.14a.85.85 0 0 1-.623-.252.85.85 0 0 1-.252-.624q0-.372.252-.623a.85.85 0 0 1 .623-.252h9.334q.372 0 .623.252a.85.85 0 0 1 .252.624.85.85 0 0 1-.252.623.85.85 0 0 1-.623.251z"
  }))));
};
export default SvgHistory;